import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { LandingPage } from '@leagueplatform/solutions-foundation';
import { ParagraphText } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import BackgroundImage from 'assets/eos-pre-login-background.jpg';
import LogoImage from 'assets/eos-health-logo.svg';
import { useNavigate } from 'react-router-dom';
import { SignInFooter } from './sign-in-footer.component';

const MOBILE_BACKGROUND_HEIGHT = '40dvh';
const SIGN_IN_BUTTON_CSS = { width: '327px', maxWidth: '327px' };

export const PreLoginLandingPage = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  // One sign-in for everyone: members and caregivers share a connection, so a
  // second entry point would only be a way to reach the wrong one.
  return (
    <LandingPage
      logo={{
        src: LogoImage,
        alt: formatMessage({ id: 'STR_APP_NAME' }),
      }}
      tagline={
        <ParagraphText emphasis="subtle">
          {formatMessage({ id: 'STR_LANDING_PAGE_TAGLINE' })}
        </ParagraphText>
      }
      backgroundImage={{ src: BackgroundImage }}
      mobileBackgroundImage={{
        height: MOBILE_BACKGROUND_HEIGHT,
        css: { backgroundPosition: 'center' },
      }}
      primaryButton={{
        buttonText: formatMessage({ id: 'STR_LOG_IN' }),
        onClick: () => navigate(APP_MANAGED_ROUTES.SIGN_IN),
        css: SIGN_IN_BUTTON_CSS,
      }}
      onAuthenticated={(appState) =>
        navigate(appState?.redirectPath || APP_MANAGED_ROUTES.HOME)
      }
      // eslint-disable-next-line no-console
      onAuthError={(error) => console.log(error)}
      signInFooter={<SignInFooter />}
      shouldDisplayErrorCaption
    />
  );
};
